import type { VariableNode } from 'services/entities/VariablesEntity';
import { useAppDispatch, useAppSelector } from '../grid/reduxStore/Store';
import { setCanPaste, setLastCopiedVariable } from '../grid/reduxStore/contextMenuSlice';
import { copyBlockToClipboard } from '../utils/clipboard';
import { selectContentType } from '../grid/reduxStore/documentSettingsSlice.ts';
import { ContentType } from '../../../utils/getContentType.ts';

export function useCopyVariableToClipboard(): (node: VariableNode) => Promise<boolean> {
  const contentType = useAppSelector(selectContentType);
  const isTemplateEditor = contentType === ContentType.TEMPLATE;
  const dispatch = useAppDispatch();

  return async (node: VariableNode) => {
    const success = await copyBlockToClipboard({ data: node, isTemplateEditor });
    if (success) {
      dispatch(setLastCopiedVariable(node));
      dispatch(setCanPaste(true));
    }
    return success;
  };
}
